import { Howl } from 'howler';
import { IS_POS } from '@/utils/env';

const soundMap = new Map<string, Howl>();

const soundResources = {
  notification: require('../assets/sounds/notification.mp3'),
  flip: require('../assets/sounds/flip.mp3'),
  click: require('../assets/sounds/click.mp3'),
  click_light: require('../assets/sounds/click_light.mp3'),
  scan_di: require('../assets/sounds/di.m4a'),
  error: require('../assets/sounds/error.mp3'),
  money: require('../assets/sounds/money.mp3'),
  collapse: 'https://cdn.sjianke.com/assets/admin/sounds/collapse.mp3',
} as const;

export type SoundTypes = keyof typeof soundResources;

export function loadSoundResources() {
  // Object.entries(soundResources).forEach(([key, url]) => {
  //   soundMap.set(
  //     key,
  //     new Howl({
  //       src: [url],
  //     })
  //   );
  // });
}

let prevSoundPlayedTimer = -1;
let prevSoundPlayedType: SoundTypes;

/**
 *
 * @param id 资源名称
 * @param preventSameType 阻止短时间内连续播放相同的资源
 * @param preventAnyTypeInDuration 阻止短时间内连续播放任何资源
 */
export function playSound(id: SoundTypes, preventSameType = true, preventAnyTypeInDuration: boolean | number = false) {
  if (!IS_POS) {
    return;
  }

  if (preventSameType && id === prevSoundPlayedType) {
    if (new Date().getTime() - prevSoundPlayedTimer < 70) {
      // 时间段内不能重复播放相同的音频资源
      return;
    }
  }

  if (!!preventAnyTypeInDuration) {
    preventAnyTypeInDuration = typeof preventAnyTypeInDuration === 'boolean' ? 70 : preventAnyTypeInDuration;
    if (new Date().getTime() - prevSoundPlayedTimer < preventAnyTypeInDuration) {
      // 时间段内不能重复播放相同的音频资源
      return;
    }
  }

  prevSoundPlayedTimer = new Date().getTime();
  prevSoundPlayedType = id;

  if (window.__POS_Device__) {
    const played = window.__POS_Device__.playSound(id);
    if (played) {
      return;
    }
  }
  if (!soundMap.has(id)) {
    soundMap.set(
      id,
      new Howl({
        src: [soundResources[id]],
      })
    );
  }
  soundMap.get(id).play();
}

export const playSoundClick = () => {
  playSound('click');
};

export const playSoundClickLight = () => {
  playSound('click_light');
};

export const playSoundFlip = () => {
  playSound('flip');
};
